import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Global firm switcher state (multi-company). `activeCompanyId: null` means
// "Toate firmele" — no firm filter is applied. Persisted so the selection
// survives reloads; hooks read it via useActiveCompanyId() and thread it as
// `companyId` into list/dashboard queries.

interface CompanyState {
  activeCompanyId: string | null;
  setActiveCompanyId: (id: string | null) => void;
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      activeCompanyId: null,
      setActiveCompanyId: (id) => set({ activeCompanyId: id }),
    }),
    { name: 'firmio-company' },
  ),
);

/** The currently selected firm id, or null = all firms. */
export function useActiveCompanyId(): string | null {
  return useCompanyStore((s) => s.activeCompanyId);
}
